function loopyThomas(points) {
  var closed = false;
  let xs = points.map((pt) => pt[0]);
  let ys = points.map((pt) => pt[1]);
  let dist = Math.sqrt(
    Math.pow(xs[points.length - 1] - xs[0], 2) +
      Math.pow(ys[points.length - 1] - ys[0], 2)
  );
  if (dist < 0.1) {
    closed = true;
    xs.pop();
    ys.pop();
  }
  let weights = [];
  let weighting = function (x1, x2, y1, y2) {
    /* calculate Euclidean distance */
    var d = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
    // if the weight is too small, the calculation becomes instable
    return d < 1 ? 1 : d;
  };

  for (var i = 0; i < xs.length - 1; i++) {
    weights[i] = weighting(xs[i + 1], xs[i], ys[i + 1], ys[i]);
  }
  // i = nPaths-1 = nKnots-1
  weights[i] = weighting(xs[0], xs[i], ys[0], ys[i]);

  let pxs = computeControlPointsCircularW(xs, weights);
  let pys = computeControlPointsCircularW(ys, weights);
  let result = [];
  for (var i = 0; i < xs.length - 1; i++) {
    result.push([
      [pxs.p1[i], pys.p1[i]],
      [pxs.p2[i], pys.p2[i]],
    ]);
  }
  if (closed) {
    let i = xs.length - 1;
    result.push([
      [pxs.p1[i], pys.p1[i]],
      [pxs.p2[i], pys.p2[i]],
    ]);
  }
  return result;

  function computeControlPointsCircularW(values, weights) {
    var W = weights.slice(); // make a copy of the array
    var K = values.slice();

    var p1, p2, n, a, b, c, r, i;
    var frac_i;

    p2 = new Array();
    n = K.length;

    /*rhs vector*/
    a = new Array();
    b = new Array();
    c = new Array();
    r = new Array();

    W[-1] = W[n - 1];
    W[n] = W[0];
    K[n] = K[0];
    for (i = 0; i < n; i++) {
      frac_i = W[i] / W[i + 1];
      a[i] = 1 * W[i] * W[i];
      b[i] = 2 * W[i - 1] * (W[i - 1] + W[i]);
      c[i] = W[i - 1] * W[i - 1] * frac_i; // W[i]/W[i+1];
      r[i] =
        Math.pow(W[i - 1] + W[i], 2) * K[i] +
        Math.pow(W[i - 1], 2) * (1 + frac_i) * K[i + 1];
    }

    p1 = ThomasCircular_new(r, a, b, c);

    p1[n] = p1[0];
    for (i = 0; i < n; i++) {
      p2[i] = K[i + 1] * (1 + W[i] / W[i + 1]) - p1[i + 1] * (W[i] / W[i + 1]);
    }
    return { p1: p1, p2: p2 };
  }

  function ThomasCircular_new(r_in, a_in, b_in, c_in) {
    /*solves Ax=r by Guassian elimination (for a matrix that has many zeros)
       r: right-hand vector
      a: array of the sub-diagonal elements (indexes 1 till n-1)
      a[0] is the most up most right element (position [0,n-1])
      b: array of the diagonal elements(indexes 0 till n-1)
      c: array of the upper-diagonal elements(indexed 0 till n-2)
      c[n-1] is the lowest most left element (position [n-1,0])
      all other elements are supposed to be 0
    |   b0 c0 0  0  ...    .      .      .      a0    |
    |   a1 b1 c1 0  ...    .      .      .      0     |
    |   0  a2 b2 c2 ..     .      .      .      0     |
    |   .   . .  .  ...    .      .      .      .     |  x = r
    |   .   . .  .  ...    .      .      .      .     |
    |   0   0 0  0  ... a[n-3] b[n-3] c[n-3]    0     |
    |   0   0 0  0  ...    0   a[n-2] b[n-2]  c[n-2]  |
    |c[n-1] 0 0  0  ...    0      0   a[n-1]  b[n-1]  |
  */
    var x, i, n, m;
    var r = r_in.slice(); // creates a copy
    var a = a_in.slice(); // creates a copy
    var b = b_in.slice(); // creates a copy
    var c = c_in.slice(); // creates a copy
    n = r.length;

    // lastcolumn
    // for lc, indexes 0 till n-3 are used.
    // lc[n-2] is not used, use c[n-2]
    // lc[n-1] is not used, use b[n-1]
    var lc = new Array(n);
    lc[0] = a[0];

    // last row
    // lr contains a value from the last row
    // indexes 0 till n-3 are used.
    // lr[n-2] is not used, use a[n-1]
    // lr[n-1] is not used, use b[n-1]
    var lr = c[n - 1];

    for (i = 0; i < n - 3; i++) {
      m = a[i + 1] / b[i];
      b[i + 1] -= m * c[i];
      r[i + 1] -= m * r[i];
      // last column // superflous when i=n-2
      lc[i + 1] = -m * lc[i];

      // last row : lr=lr[i]
      m = lr / b[i];
      b[n - 1] -= m * lc[i];
      lr = -m * c[i]; // lr=lr[i+1], superflous when i=n-2
      // lr[i]=0 maar deze waarde wordt niet meer gebruikt
      r[n - 1] -= m * r[i];
    }
    // note that i = n-3 now
    {
      m = a[i + 1] / b[i];
      b[i + 1] -= m * c[i];
      r[i + 1] -= m * r[i];
      // last column
      // in stead of lc[i+1]=-m*lc[i]
      c[i + 1] -= m * lc[i];
      // last row
      m = lr / b[i];
      b[n - 1] -= m * lc[i];
      // in stead of lr[i+1]= - m * c[i] // superflous when i=n-2
      a[n - 1] -= m * c[i];
      // lr[i]=0 maar deze waarde wordt niet meer gebruikt
      r[n - 1] = r[n - 1] - m * r[i];
    }
    i = n - 2;
    // in stead of: for (i = n-1; i < n; i++)
    {
      m = a[i + 1] / b[i];
      // in stead of lr[i+1]= - m * c[i]
      b[i + 1] -= m * c[i];
      // in stead of r[n-1]= r[n-1] - m * r[i] // reeds gedaan
      r[i + 1] -= m * r[i];

      // last column
      // lc[i+1] wordt niet gebruikt, dit is b[i+1]

      // last row
      // lr[i] wordt niet gebruikt, dit is a[i+1]

      // m = lr[i]/b[i];
      // b[i+1] -=  m * c[i] // reeds gedaan
      // lr[i]=0
    }

    x = new Array(n);

    x[n - 1] = r[n - 1] / b[n - 1];
    // the value of lc[n-2] should not be used in the loop
    lc[n - 2] = 0;
    for (i = n - 2; i >= 0; --i) {
      x[i] = (r[i] - c[i] * x[i + 1] - lc[i] * x[n - 1]) / b[i];
    }
    return x;
  }
}

export { loopyThomas };
